import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

function ErrorFallback({ resetErrorBoundary }) {
  return (
    <div className="error-boundary" role="alert">
      <h2>Something went wrong.</h2>
      <p>
        Please refresh the page. If the problem persists, contact us directly.
      </p>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  );
}

const ErrorBoundary = ({ children }) => (
  <ReactErrorBoundary
    FallbackComponent={ErrorFallback}
    onError={(error, info) =>
      console.error('ErrorBoundary caught:', error, info.componentStack)
    }
  >
    {children}
  </ReactErrorBoundary>
);

export default ErrorBoundary;
